import { createActions, createReducer } from 'reduxsauce'

import PortalService from '../servicos/PortalService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConteudoInicio: [],
    buscaConteudoSucesso: ['conteudo'],
    buscaConteudoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

Creators.buscaConteudo = id => {
    return dispatch => {
        dispatch(Creators.buscaConteudoInicio())
        let serv = new PortalService()
        return serv
            .getConteudoPorId(id)
            .then(response => dispatch(Creators.buscaConteudoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConteudoErro(error)))
    }
}

const buscaConteudoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaConteudoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConteudoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, conteudo: action.conteudo, carregando: false }
}

export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTEUDO_INICIO]: buscaConteudoInicio,
    [Types.BUSCA_CONTEUDO_ERRO]: buscaConteudoErro,
    [Types.BUSCA_CONTEUDO_SUCESSO]: buscaConteudoSucesso,
})
